import { INotificationComponent } from '../../../../../types/componentInterfaces/inotificationcomponent';
import { NotificationTypeService } from '../../../../../services/data/notificationtype.service';
import { Component, inject, OnInit, input, output, viewChild } from '@angular/core';
import { ButtonText, Claims, Contact, RecordableCategory } from '../../../../../types';
import { NotificationTypeEnum } from '../../../../../types/enums/notificationtypeenum';
import { NotificationType } from '../../../../../types/notificationtype';
import { CommandButtonComponent } from '../../../../pcpcommandbar/commandbutton/commandbutton.component';
import { PcpCommandBarComponent } from '../../../../pcpcommandbar/pcp-commandbar.component';
import { RecordableNotificationsComponent } from './recordable.notifications/recordable.notifications.component';
import { ChangeOrderNotificationsComponent } from './changeorder.notifications/changeorder.notifications.component';

import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { DrawerModule } from 'primeng/drawer';
import { takeUntil } from 'rxjs';
import { UnsubscribeOnDestroy } from '../../../../../classes';
import { CheckAccessDirective } from '../../../../../directives/access.directive';

@Component({
	selector: 'add-edit-notifications',
	templateUrl: './addeditnotifications.component.html',
	styleUrls: ['./addeditnotifications.component.scss'],
	standalone: true,
  imports: [DrawerModule, SelectModule, FormsModule, ChangeOrderNotificationsComponent, RecordableNotificationsComponent, PcpCommandBarComponent, CommandButtonComponent, CheckAccessDirective]
})
export class AddEditNotificationsComponent extends UnsubscribeOnDestroy implements OnInit {
	types: NotificationType[] = [];
	selectedNotificationTypeId: number;
	selectedCategories: RecordableCategory[] = [];
	selectedOwners: Contact[] = [];
	isSwitchOn: boolean = false;
	isDirty: boolean;
	sidebarTitle: string;
	notificationId: number;
	filteredNotificationTypes: NotificationType[];
	ButtonText = ButtonText;
	Claims = Claims;
	showSideBar: boolean = false;

	public get NotificationTypeEnum() {
		return NotificationTypeEnum;
	}

	readonly notificationComp = viewChild<INotificationComponent>("NotificationComp");

	readonly refreshGridFromChildEvent = output<boolean>();
	readonly excludedNotificationTypes = input<NotificationTypeEnum[]>(undefined);

	private notificationTypeService = inject(NotificationTypeService);

	constructor() { super(); }

	ngOnInit(): void {
		this.getNotificationTypes();
	}

	getNotificationTypes(): void {
		this.notificationTypeService.getNotificationsType()
			.pipe(takeUntil(this.ngUnsubscribe$))
			.subscribe((types) => {
				this.types = types.sort((a, b) => a.notificationTypeName > b.notificationTypeName ? 1 : -1);
			});
	}

	showEdit(notificationId: number, notificationTypeId: number) {
		this.selectedNotificationTypeId = notificationTypeId;
		this.notificationId = notificationId;
		this.sidebarTitle = "Edit Notification";
		this.showSideBar = true;
		this.filteredNotificationTypes = this.types;
		this.loadNotification();
	}

	showAdd(): void {
		this.selectedNotificationTypeId = null;
		this.notificationId = 0;
		this.sidebarTitle = "Add Notification";
		this.showSideBar = true;
		if (this.excludedNotificationTypes().length > 0) {
			this.filteredNotificationTypes = this.types.filter((t) => this.excludedNotificationTypes().find((enf) => enf !== t.notificationTypeId));
		} else {
			this.filteredNotificationTypes = this.types; // show all types.
		}
	}

	loadNotification() {
		setTimeout(() => {
			this.notificationComp().load(this.notificationId);
		}, 450);
	}

	getCloseStatus(e) {
		this.showSideBar = false;
		if (e) {
			this.refreshGridFromChildEvent.emit(e);
		}
	}
}
